import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Textarea, Group, Flex, Text, Box, Paper, Divider, Avatar, Button, Select, Badge, Mark, Checkbox, Menu, ActionIcon, Card } from '@mantine/core';
import { IconTrash, IconPlus, IconPencil, IconDotsVertical } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { sqlDateToHumanDate, regexNumberOnly, safeValue, getObjectParam2, masaGaransiUtils__1, masaGaransiUtils__2, batalPemakaianSelectorByGaransiTypeCanBeClaimed, stringDivider, findValueOfKeyInObject3Layers } from "../../utils/globalFunctions";

import { canAccessModifyPengerjaan } from "../../utils/accessing";

import ModalWrapperWithFooterCloseButton from "../../components/general/ModalWrapperWithFooterCloseButton";
import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import PaperWrapper from "../../components/utilities/PaperWrapper";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import InputComponent from "../../components/general/InputComponent";
import LabelContentInline from "../../components/general/LabelContentInline";

import FileSelectorComponent from "../../components/general/FileSelectorComponent";

import ComponentStockSelector from "../../pagesSub/trxProjectPengerjaan/ComponentStockSelector";
import CarouselPhotos from "../../components/general/CarouselPhotos";

import StepPengerjaanReminderMaintenanceModal from "./StepPengerjaanReminderMaintenanceModal";

// info: MIME TYPE SOLVED
// info: HEIC CONVERTER IN ANOTHER FILE

const StepPengerjaan = ({
  stateData,
  stateShowNextComponent = false,
  fnClickPhoto,
  fnCloseDrawer,
  fnSuccessTakesThisProject
}) => {
  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'componentPengerjaanProgress-1',
    errorGetDataTaggedItem: 'componentPengerjaanProgress-1b',

    errorAddProgress: 'componentPengerjaanProgress-2',
    errorAddPengecekan: 'componentPengerjaanProgress-2b',
    errorEditDesc: 'componentPengerjaanProgress-3',
    errorBatalkanItem: 'componentPengerjaanProgress-4',
    errorUploadImage: 'componentPengerjaanProgress-5',
    errorDeleteImage: 'componentPengerjaanProgress-6',
    errorDeletePostingProgress: 'componentPengerjaanProgress-7',
    errorBatalkanProgress: 'componentPengerjaanProgress-8',

    successSubmitData: 'componentPengerjaanProgress-9',
  })

  const refDefaultGaransiType = React.useRef(utils.batalPemakaianItem.salah_pilih.slug);

  const [data, setData] = React.useState({
    data: [],
    dataFlag: 'idle',
    dataLoading: false,

    projectId: '',
    clientId: '',
    clientName: '',

    addProgressModal: false,
    addProgressValue: '',
    addProgressError: '',
    addProgressSubmitLoading: false,

    addPengecekanModal: false,
    addPengecekanValue: '',
    addPengecekanError: '',
    addPengecekanSubmitLoading: false,

    editDescModal: false,
    editDescValue: '',
    editDescProgresId: '',
    editDescError: '',
    editDescSubmitLoading: false,

    fileUploading: false,
    fileUploadingProgress: 0,

    deletePhoto: {
      photoId: '',
      photoName: '',
      confirmation: false,
      progressPengerjaanId: '',
      deleteLoading: false
    },

    posting: {
      progressPengerjaanId: '',
      confirmation: false,
      postingLoading: false
    },

    batalkanProgress: {
      progressPengerjaanId: '',
      confirmation: false,
      batalkanLoading: false
    },

    batalPemakaianModal: false,
    batalPemakaianItemData: {
      stockId: '',
      pengerjaanId: '',
      pengerjaanStockId: '',
      name: '',
      itemStatus: '',
      masaGaransiType: '',
      masaGaransiBulan: '',
      masaGaransiHari: '',
      masaGaransiCanBeClaimed: '',
      tanggalPembelian: '',
      clientId: '',
      clientName: '',
      projectId: '',
      // taggedClientId: '',
      // taggedProjectId: ''
    },

    batalPemakaianType: refDefaultGaransiType.current,
    batalPemakaianJumlah: '',
    batalPemakaianError: '',
    batalPemakaianKeterangan: '',
    batalPemakaianLoadingSubmit: false,

    batalPemakaianIsTaggedForClientId: false,
    batalPemakaianIsTaggedForClientIdDisabled: false,
    batalPemakaianIsTaggedForProjectId: false,

    stockSelectorModal: false,
    stockSelectorTriggerUpdate: false,

    submitConfirmationModal: false,

    taggedInfo: {
      modal: false,
      customerName: '',
      projectId: ''
    },

    taggedItemInMasterStock: [],
    taggedItemInGaransiProcess: [],

    taggedItemLoading: false,
    taggedItemRefresh: new Date(),

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  // React.useEffect(() => {
  //   if (data.batalPemakaianItemData.taggedProjectId === data.batalPemakaianItemData.projectId) {
  //     setData(d => ({
  //       ...d,
  //       batalPemakaianIsTaggedForClientId: true,
  //       batalPemakaianIsTaggedForClientIdDisabled: true,
  //       batalPemakaianIsTaggedForProjectId: true
  //     }))
  //   } else {
  //     if (data.batalPemakaianItemData.taggedClientId === data.batalPemakaianItemData.clientId) {
  //       setData(d => ({
  //         ...d,
  //         batalPemakaianIsTaggedForClientId: true,
  //         batalPemakaianIsTaggedForClientIdDisabled: false,
  //         batalPemakaianIsTaggedForProjectId: false
  //       }))
  //     } else {
  //       setData(d => ({
  //         ...d,
  //         batalPemakaianIsTaggedForClientId: false,
  //         batalPemakaianIsTaggedForClientIdDisabled: false,
  //         batalPemakaianIsTaggedForProjectId: false
  //       }))
  //     }
  //   }
  // }, [data.batalPemakaianItemData.taggedClientId, data.batalPemakaianItemData.taggedProjectId, data.batalPemakaianItemData.projectId, data.batalPemakaianItemData.clientId])

  const taggedInit = (stateTaggedProjectId, stateProjectId, stateTaggedClientId, stateClientId) => {
    if (stateTaggedProjectId === stateProjectId) {
      setData(d => ({
        ...d,
        batalPemakaianIsTaggedForClientId: true,
        batalPemakaianIsTaggedForClientIdDisabled: true,
        batalPemakaianIsTaggedForProjectId: true
      }))
    } else {
      if (stateTaggedClientId === stateClientId) {
        setData(d => ({
          ...d,
          batalPemakaianIsTaggedForClientId: true,
          batalPemakaianIsTaggedForClientIdDisabled: false,
          batalPemakaianIsTaggedForProjectId: false
        }))
      } else {
        setData(d => ({
          ...d,
          batalPemakaianIsTaggedForClientId: false,
          batalPemakaianIsTaggedForClientIdDisabled: false,
          batalPemakaianIsTaggedForProjectId: false
        }))
      }
    }
  }

  React.useEffect(() => {
    if (data.batalPemakaianIsTaggedForProjectId) {
      setData(d => ({
        ...d,
        batalPemakaianIsTaggedForClientId: true,
        batalPemakaianIsTaggedForClientIdDisabled: true
      }))
    } else {
      setData(d => ({
        ...d,
        batalPemakaianIsTaggedForClientId: false,
        batalPemakaianIsTaggedForClientIdDisabled: false
      }))
    }
  }, [data.batalPemakaianIsTaggedForProjectId])

  React.useEffect(() => {
    if (stateData.projectId) {
      setData(d => ({ ...d, dataLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', stateData.projectId);
      formDT.append('project_process', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);

      axios({
        method: 'post',
        url: BE_API_TWO + '/pengerjaan_progress',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, dataLoading: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            data: response.data.data,
            dataFlag: response.data.data.length > 0 ? true : false,

            projectId: response.data.project_id,
            clientId: response.data.client_id,
            clientName: response.data.client_name,
          }));
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, dataLoading: false }));

        notifications.show({
          id: notificationId.current.errorGetData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [handleSetLoginContext, loginContext.syswebapp, stateData.projectId, stateData.projectProcess, stateData.projectIsCancel])

  // ! Get Tagged Item
  React.useEffect(() => {
    if (stateData.projectId) {
      setData(d => ({ ...d, taggedItemLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', stateData.projectId);
      formDT.append('project_process', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);
      formDT.append('stock_item_tagging_status_obj', JSON.stringify(utils.stockItemStatus));
      formDT.append('stock_item_garansi_status_obj', JSON.stringify(utils.statusItemGaransi));

      axios({
        method: 'post',
        url: BE_API_TWO + '/get_tagged_item',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, taggedItemLoading: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            taggedItemInMasterStock: Array.isArray(response.data.data_tagged_item_in_master_stock) ? response.data.data_tagged_item_in_master_stock : [],

            taggedItemInGaransiProcess: Array.isArray(response.data.data_tagged_item_in_garansi_process) ? response.data.data_tagged_item_in_garansi_process : [],
          }));
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, taggedItemLoading: false }));

        notifications.show({
          id: notificationId.current.errorGetDataTaggedItem,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [handleSetLoginContext, loginContext.syswebapp, stateData.projectId, stateData.projectProcess, stateData.projectIsCancel, data.taggedItemRefresh])

  const addProgress = () => {
    setData(d => ({ ...d, addProgressError: '' }));

    if (validator.isEmpty(data.addProgressValue, { ignore_whitespace: true })) {
      setData(d => ({ ...d, addProgressError: 'Progres wajib diisi.' }));
    } else {

      setData(d => ({ ...d, addProgressSubmitLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', data.projectId);
      formDT.append('project_process', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);
      formDT.append('value', data.addProgressValue);
      formDT.append('pengerjaan_progress_flag', utils.pengerjaanProgress.pengerjaan.value);

      axios({
        method: 'post',
        url: BE_API_TWO + '/add_pengerjaan_progress',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, addProgressSubmitLoading: false, addProgressModal: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            data: response.data.data,
            dataFlag: response.data.data.length > 0 ? true : false,
            addProgressValue: '',
          }));
        }

        if (response.data.flag_status === 'terdapat-progres-belum-diposting') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Uppss.. Terdapat progres yang belum Anda posting !',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorAddProgress,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, addProgressSubmitLoading: false, addProgressModal: false }));

        notifications.show({
          id: notificationId.current.errorAddProgress,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  const addPengecekan = () => {
    setData(d => ({ ...d, addPengecekanError: '' }));

    if (validator.isEmpty(data.addPengecekanValue, { ignore_whitespace: true })) {
      setData(d => ({ ...d, addPengecekanError: 'Pengecekan wajib diisi.' }));
    } else {

      setData(d => ({ ...d, addPengecekanSubmitLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', data.projectId);
      formDT.append('project_process', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);
      formDT.append('value', data.addPengecekanValue);
      formDT.append('pengerjaan_progress_flag', utils.pengerjaanProgress.pengerjaan.value);

      axios({
        method: 'post',
        url: BE_API_TWO + '/add_pengecekan_progress',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, addPengecekanSubmitLoading: false, addPengecekanModal: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            data: response.data.data,
            dataFlag: response.data.data.length > 0 ? true : false,
            addPengecekanValue: '',
          }));
        }

        if (response.data.flag_status === 'terdapat-progres-belum-diposting') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Uppss.. Terdapat progres yang belum Anda posting !',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorAddPengecekan,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, addPengecekanSubmitLoading: false, addPengecekanModal: false }));

        notifications.show({
          id: notificationId.current.errorAddPengecekan,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  const editDesc = () => {
    setData(d => ({ ...d, editDescError: '' }));

    if (validator.isEmpty(data.editDescValue, { ignore_whitespace: true })) {
      setData(d => ({ ...d, editDescError: 'Progres wajib diisi.' }));
    } else {

      setData(d => ({ ...d, editDescSubmitLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', data.projectId);
      formDT.append('project_process', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);
      formDT.append('value', data.editDescValue);
      formDT.append('project_pengerjaan_id', data.editDescProgresId);
      formDT.append('pengerjaan_progress_flag', utils.pengerjaanProgress.pengerjaan.value);

      axios({
        method: 'post',
        url: BE_API_TWO + '/edit_pengerjaan_progress_description',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, editDescSubmitLoading: false, editDescModal: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            data: response.data.data,
            dataFlag: response.data.data.length > 0 ? true : false,
            editDescValue: '',
            editDescProgresId: ''
          }));
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorEditDesc,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'can-not-be-edit') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak dapat diubah !',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, editDescSubmitLoading: false, editDescModal: false }));

        notifications.show({
          id: notificationId.current.errorEditDesc,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  const batalkanPemakaianPart = () => {
    setData(d => ({ ...d, batalPemakaianError: '' }));

    if (parseInt(Number(data.batalPemakaianJumlah)) <= 0) {
      setData(d => ({ ...d, batalPemakaianError: 'Jumlah item wajib diisi.' }));
    } else if ((data.batalPemakaianType !== utils.batalPemakaianItem.salah_pilih.slug) && validator.isEmpty(data.batalPemakaianKeterangan, { ignore_whitespace: true })) {
      setData(d => ({ ...d, batalPemakaianError: 'Keterangan wajib diisi' }));
    } else {
      setData(d => ({
        ...d,
        batalPemakaianLoadingSubmit: true,
      }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', data.projectId);
      formDT.append('project_process', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);

      formDT.append('stock_id', data.batalPemakaianItemData.stockId);
      formDT.append('pengerjaan_id', data.batalPemakaianItemData.pengerjaanId);
      formDT.append('pengerjaan_stock_id', data.batalPemakaianItemData.pengerjaanStockId);
      formDT.append('pengerjaan_progress_flag', utils.pengerjaanProgress.pengerjaan.value);
      formDT.append('jumlah_pemakaian_item', data.batalPemakaianJumlah);
      formDT.append('pembatalan_type', data.batalPemakaianType);
      formDT.append('pembatalan_type_list', JSON.stringify(utils.batalPemakaianItem));
      formDT.append('keterangan_pembatalan', data.batalPemakaianKeterangan);

      formDT.append('is_tagged_for_client', data.batalPemakaianIsTaggedForClientId);
      formDT.append('is_tagged_for_project', data.batalPemakaianIsTaggedForProjectId);
      formDT.append('client_id', data.batalPemakaianItemData.clientId);

      formDT.append('status_item_garansi_pengajuan', utils.statusItemGaransi.pengajuan_klaim_garansi.value);
      formDT.append('garansi_reference', utils.garansiReference.project_pengerjaan.value);

      formDT.append('pengerjaan_progress_flag_item_cancelled', JSON.stringify(utils.pengerjaanProgress.itemCancelled));
      formDT.append('item_name', data.batalPemakaianItemData.name);

      axios({
        method: 'post',
        url: BE_API_TWO + '/batalkan_pemakaian_item',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, batalPemakaianLoadingSubmit: false, batalPemakaianModal: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            taggedItemRefresh: new Date(),

            data: response.data.data,
            dataFlag: response.data.data.length > 0 ? true : false,

            batalPemakaianJumlah: '',
            batalPemakaianError: '',
            batalPemakaianKeterangan: '',

            batalPemakaianIsTaggedForClientId: false,
            batalPemakaianIsTaggedForClientIdDisabled: false,
            batalPemakaianIsTaggedForProjectId: false,
          }));
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorBatalkanItem,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'can-not-be-edit') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak dapat diubah !',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'sepertinya-telah-terjadi-kesalahan') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Sepertinya telah terjadi kesalahan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'input-lebih-besar-dari-aktual') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: `Jumlah yang Anda masukkan lebih besar dari jumlah seharusnya !`,
              show: true
            }
          }))
        }
        //

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          batalPemakaianLoadingSubmit: false,
          batalPemakaianModal: false
        }))

        notifications.show({
          id: notificationId.current.errorBatalkanItem,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  const uploadFile = (stateFile, projectPengerjaanId) => {
    setData(d => ({ ...d, fileUploading: true }));

    const formDT = new FormData();
    const formDTHeader = { Accept: 'application/json', 'Content-Type': 'multipart/form-data' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_id', data.projectId);
    formDT.append('project_process', stateData.projectProcess);
    formDT.append('project_is_cancel', stateData.projectIsCancel);

    formDT.append('project_pengerjaan_id', projectPengerjaanId);
    formDT.append('pengerjaan_progress_flag', utils.pengerjaanProgress.pengerjaan.value);

    formDT.append('photos[0]', stateFile);
    formDT.append('image_max_size_in_mb', utils.imageMaxSizeUploadFotoInMB);
    formDT.append('file_type_accepted', '');

    // info: file type accepted di handle di BE

    axios({
      method: 'post',
      url: BE_API_TWO + '/add_project_barang_foto_pengerjaan',
      data: formDT,
      headers: formDTHeader,
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

        setData(d => ({ ...d, fileUploadingProgress: percentCompleted }));
      }
    }).then((response) => {
      if (!mountedRef.current) return null;

      // setData(d => ({ ...d, fileUploading: false, fileUploadingProgress: 0 }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({
          ...d,
          data: response.data.data,
          dataFlag: response.data.data.length > 0 ? true : false,
        }));

        setData(d => ({ ...d, fileUploading: false, fileUploadingProgress: 0 }));
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'can-not-be-edit') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak dapat diubah !',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'error') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Error : ' + response.data.pesan,
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'wrong-type') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: `"${response.data.suspect}" tidak sesuai dengan format yang diizinkan (${response.data.allowed}).`,
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'wrong-size') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: `"${response.data.suspect}" melebihi ukuran yang diizinkan (${response.data.max_size}).`,
            show: true
          }
        }))
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, fileUploading: false }))

      notifications.show({
        id: notificationId.current.errorUploadImage,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  const deletePhoto = () => {

    setData(d => ({ ...d, deletePhoto: { ...d.deletePhoto, deleteLoading: true } }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_id', data.projectId);
    formDT.append('project_process', stateData.projectProcess);
    formDT.append('project_is_cancel', stateData.projectIsCancel);

    formDT.append('project_pengerjaan_id', data.deletePhoto.progressPengerjaanId);
    formDT.append('pengerjaan_progress_flag', utils.pengerjaanProgress.pengerjaan.value);

    formDT.append('foto_pengerjaan_id', data.deletePhoto.photoId);
    formDT.append('foto_pengerjaan_name', data.deletePhoto.photoName);

    axios({
      method: 'post',
      url: BE_API_TWO + '/delete_project_barang_foto_pengerjaan',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        deletePhoto: {
          ...d.deletePhoto,
          deleteLoading: false,
          confirmation: false
        }
      }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({
          ...d,
          data: response.data.data,
          dataFlag: response.data.data.length > 0 ? true : false,
        }));
      }

      if (response.data.flag_status === 'error') {
        notifications.show({
          id: notificationId.current.errorDeleteImage,
          title: utils.notification.warning.caption,
          message: response.data.pesan,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      }

      if (response.data.flag_status === 'can-not-be-edit') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak dapat diubah !',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        deletePhoto: {
          ...d.deletePhoto,
          deleteLoading: false,
          confirmation: false
        }
      }));

      notifications.show({
        id: notificationId.current.errorDeleteImage,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  const postingProgress = () => {
    setData(d => ({
      ...d,
      posting: {
        ...d.posting,
        postingLoading: true
      }
    }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_id', data.projectId);
    formDT.append('project_process', stateData.projectProcess);
    formDT.append('project_is_cancel', stateData.projectIsCancel);

    formDT.append('project_pengerjaan_id', data.posting.progressPengerjaanId);
    formDT.append('pengerjaan_progress_flag', utils.pengerjaanProgress.pengerjaan.value);

    axios({
      method: 'post',
      url: BE_API_TWO + '/posting_progress',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        posting: {
          ...d.posting,
          postingLoading: false,
          confirmation: false
        }
      }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({
          ...d,
          data: response.data.data,
          dataFlag: response.data.data.length > 0 ? true : false,
        }));
      }

      if (response.data.flag_status === 'error') {
        notifications.show({
          id: notificationId.current.errorDeletePostingProgress,
          title: utils.notification.warning.caption,
          message: response.data.pesan,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      }

      if (response.data.flag_status === 'can-not-be-edit') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak dapat diubah !',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        posting: {
          ...d.posting,
          postingLoading: false,
          confirmation: false
        }
      }));

      notifications.show({
        id: notificationId.current.errorDeletePostingProgress,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  const batalkanProgress = () => {
    setData(d => ({
      ...d,
      batalkanProgress: {
        ...d.batalkanProgress,
        batalkanLoading: true
      }
    }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_id', data.projectId);
    formDT.append('project_process', stateData.projectProcess);
    formDT.append('project_is_cancel', stateData.projectIsCancel);

    formDT.append('project_pengerjaan_id', data.batalkanProgress.progressPengerjaanId);
    formDT.append('pengerjaan_progress_flag', utils.pengerjaanProgress.pengerjaan.value);

    axios({
      method: 'post',
      url: BE_API_TWO + '/batalkan_progress',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        batalkanProgress: {
          ...d.batalkanProgress,
          batalkanLoading: false,
          confirmation: false
        }
      }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({
          ...d,
          data: response.data.data,
          dataFlag: response.data.data.length > 0 ? true : false,
        }));
      }

      if (response.data.flag_status === 'error') {
        notifications.show({
          id: notificationId.current.errorBatalkanProgress,
          title: utils.notification.warning.caption,
          message: response.data.pesan,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      }

      if (response.data.flag_status === 'can-not-be-edit') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak dapat diubah !',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'set-foto') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Hapus foto terlebih dahulu untuk membatalkan progres ini.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'set-stock') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Batalkan penggunaan part terlebih dahulu untuk membatalkan progres ini.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        batalkanProgress: {
          ...d.batalkanProgress,
          batalkanLoading: false,
          confirmation: false
        }
      }));

      notifications.show({
        id: notificationId.current.errorBatalkanProgress,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  return (
    <React.Fragment>
      {data.dataLoading &&
        <PaperWrapper mb='sm'>
          <Text size='sm' color="dimmed">Loading Data Pengerjaan..</Text>
        </PaperWrapper>
      }

      {!data.dataLoading && Array.isArray(data.data) && (data.data.length <= 0) &&
        <Text color="dimmed" align="center" py='2rem'>No Data</Text>
      }

      {!data.dataLoading && Array.isArray(data.data) && (data.data.length > 0) &&
        <Box>
          <Text
            mt='lg'
            mb='sm'
            tt='uppercase'
          >
            Progres Pengerjaan
          </Text>

          {data.taggedItemLoading &&
            <Text size='sm' color="dimmed" mb='sm'>Loading Data Tagged Stock..</Text>
          }

          {Array.isArray(data.taggedItemInMasterStock) && (data.taggedItemInMasterStock.length > 0) && !data.taggedItemLoading &&
            <CardTaggedItem>
              <Text
                size='sm'
                fw={500}
                tt='uppercase'
              >
                Item yang di tag dari data stock
              </Text>

              <Divider my='sm' />

              {Object.keys(data.taggedItemInMasterStock).map((keyTIMS, idxTIMS) => {
                return (
                  <Group
                    key={keyTIMS}
                    noWrap
                    align='flex-start'
                    spacing='xs'

                    sx={(tema) => ({
                      '&:not(:last-of-type)': {
                        marginBottom: tema.spacing.sm
                      }
                    })}
                  >
                    <Text size='sm'>
                      {Number(idxTIMS) + 1}.
                    </Text>

                    <Box>
                      <Text size='sm' mb='.25rem' fw={500}>
                        {`${data.taggedItemInMasterStock[keyTIMS].stock_category_name} ${data.taggedItemInMasterStock[keyTIMS].stock_category_sub_name} ${safeValue(data.taggedItemInMasterStock[keyTIMS].stock_serial_number, '')} (${data.taggedItemInMasterStock[keyTIMS].stock_jumlah} pcs)`}
                      </Text>

                      <Group spacing='xs'>
                        {data.taggedItemInMasterStock[keyTIMS].tagged_client_id === data.clientId &&
                          <BadgeCustomGreen
                            stateLabel='Untuk Client Ini'
                          />
                        }

                        {data.taggedItemInMasterStock[keyTIMS].tagged_project_id === data.projectId &&
                          <BadgeCustomGreen
                            stateLabel='Untuk Project Ini'
                          />
                        }
                      </Group>
                    </Box>
                  </Group>
                )
              })}
            </CardTaggedItem>
          }

          {data.taggedItemLoading &&
            <Text size='sm' color="dimmed" mb='sm'>Loading Data Tagged Stock..</Text>
          }

          {Array.isArray(data.taggedItemInGaransiProcess) && (data.taggedItemInGaransiProcess.length > 0) && !data.taggedItemLoading &&
            <CardTaggedItem>
              <Text
                size='sm'
                fw={500}
                tt='uppercase'
              >
                Item yang di tag dari proses garansi
              </Text>

              <Divider my='sm' />

              {Object.keys(data.taggedItemInGaransiProcess).map((keyTIGP, idxTIGP) => {
                return (
                  <Group
                    key={keyTIGP}
                    noWrap
                    align='flex-start'
                    spacing='xs'

                    sx={(tema) => ({
                      '&:not(:last-of-type)': {
                        marginBottom: tema.spacing.sm
                      }
                    })}
                  >
                    <Text size='sm'>
                      {Number(idxTIGP) + 1}.
                    </Text>

                    <Box>
                      <Text size='sm' mb='.25rem' fw={500}>
                        {`${data.taggedItemInGaransiProcess[keyTIGP].stock_category_name} ${data.taggedItemInGaransiProcess[keyTIGP].stock_category_sub_name} ${safeValue(data.taggedItemInGaransiProcess[keyTIGP].stock_serial_number, '')} (${data.taggedItemInGaransiProcess[keyTIGP].stock_jumlah} pcs)`}
                      </Text>

                      <BadgeCustomRed
                        stateLabel={findValueOfKeyInObject3Layers(utils.statusItemGaransi, 'value', data.taggedItemInGaransiProcess[keyTIGP].stock_garansi_detil_item_status, 'caption', ' - ')}
                      />

                      <Group spacing='xs'>
                        {data.taggedItemInGaransiProcess[keyTIGP].tagged_client_id === data.clientId &&
                          <BadgeCustomGreen
                            stateLabel='Untuk Client Ini'
                          />
                        }

                        {data.taggedItemInGaransiProcess[keyTIGP].tagged_project_id === data.projectId &&
                          <BadgeCustomGreen
                            stateLabel='Untuk Project Ini'
                          />
                        }
                      </Group>
                    </Box>
                  </Group>
                )
              })}
            </CardTaggedItem>
          }

          {Object.keys(data.data).map((key, index) => {
            return (
              <Box key={key} mb='sm'>
                <PaperWrapper>
                  <Flex
                    wrap='nowrap'
                    gap="sm"
                    justify="flex-start"
                    align="flex-start"
                  >
                    <Box>
                      <Avatar radius="xl" size='sm' color="blue">{Number(key) + 1}</Avatar>
                    </Box>

                    {/* suspect flex: 1 atau width: '100%' atau flexGrow: 1 */}
                    <Box sx={{ flex: 1 }}>
                      <Text size='sm' fw={500}>{data.data[key].project_pengerjaan_teknisi_name}</Text>
                      <Text size='sm' color="dimmed">
                        {sqlDateToHumanDate({
                          stateDate: data.data[key].project_pengerjaan_created_datetime,
                          stateWithTime: true,
                          stateLang: 'id',
                          stateIsShort: false,
                          stateDay: true,
                          stateDefaultValue: ' - ',
                          stateDateType: 'day'
                        })}
                      </Text>
                    </Box>

                    {data.data[key].project_pengerjaan_flag === utils.pengerjaanProgress.pengerjaan.value &&
                      Number(data.data[key].project_pengerjaan_is_sudah_posting) === 0 &&
                      stateData.projectProcess === utils.projectProcess.pengerjaan.value &&
                      canAccessModifyPengerjaan({ stateObject: { subLevel: loginContext } }) &&
                      <ActionIcon
                        size='md'
                        variant="subtle"
                        radius='xl'

                        sx={(tema) => ({
                          backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[5],
                          '&:hover': {
                            backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[2] : tema.colors.dark[4]
                          },
                        })}

                        onClick={() => {
                          setData(d => ({
                            ...d,
                            batalkanProgress: {
                              ...d.batalkanProgress,
                              progressPengerjaanId: data.data[key].project_pengerjaan_id,
                              confirmation: true
                            }
                          }))
                        }}
                      >
                        <IconTrash size='1rem' />
                      </ActionIcon>
                    }
                  </Flex>

                  <Divider my='sm' />

                  {Number(data.data[key].project_pengerjaan_is_pengecekan) === 1 &&
                    <Box mb='xs'>
                      <Badge
                        size='md'
                        color='teal'

                        styles={(tema) => ({
                          inner: {
                            fontWeight: 'normal',
                            textTransform: 'none',
                          }
                        })}
                      >
                        Pengecekan
                      </Badge>
                    </Box>
                  }

                  {/* suspect flex: 1 atau width: '100%' atau flexGrow: 1 */}
                  <Flex
                    wrap='nowrap'
                    gap="sm"
                    justify="flex-start"
                    align="flex-start"
                  >
                    <Text size='sm' color="dimmed" sx={{ flex: 1 }}>
                      {data.data[key].project_pengerjaan_description}
                    </Text>

                    {data.data[key].project_pengerjaan_flag === utils.pengerjaanProgress.pengerjaan.value &&
                      Number(data.data[key].project_pengerjaan_is_sudah_posting) === 0 &&
                      stateData.projectProcess === utils.projectProcess.pengerjaan.value &&
                      canAccessModifyPengerjaan({ stateObject: { subLevel: loginContext } }) &&
                      <ActionIcon
                        size='md'
                        variant="subtle"
                        radius='xl'

                        sx={(tema) => ({
                          backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[5],
                          '&:hover': {
                            backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[2] : tema.colors.dark[4]
                          },
                        })}

                        onClick={() => setData(d => ({
                          ...d,
                          editDescValue: data.data[key].project_pengerjaan_description,
                          editDescProgresId: data.data[key].project_pengerjaan_id,
                          editDescModal: true
                        }))}
                      >
                        <IconPencil size='1rem' />
                      </ActionIcon>
                    }
                  </Flex>

                  {Array.isArray(data.data[key].penggunaan_stock) && data.data[key].penggunaan_stock.length > 0 &&
                    <Box>
                      <Divider my='sm' />

                      {Object.keys(data.data[key].penggunaan_stock).map((keyPS, indexPS) => {
                        return (
                          <Group
                            key={keyPS}
                            // spacing={8}
                            align='flex-start'
                            mb='sm'
                            noWrap
                            position="apart"
                          >
                            <Group
                              spacing={8}
                              align='flex-start'
                              noWrap
                            >
                              <Text size='sm'>{Number(keyPS) + 1}.</Text>

                              <Box>
                                <Group spacing={6}>
                                  <Text
                                    size='sm'
                                    sx={{
                                      wordBreak: 'break-word'
                                    }}
                                  >
                                    {safeValue(data.data[key].penggunaan_stock[keyPS].stock_category_name, ' ')} {safeValue(data.data[key].penggunaan_stock[keyPS].stock_category_sub_name, ' ')} {safeValue(data.data[key].penggunaan_stock[keyPS].stock_serial_number, ' ')}
                                  </Text>

                                  <Badge
                                    size='md'
                                    color={getObjectParam2(utils.stockItemStatus, data.data[key].penggunaan_stock[keyPS].stock_status, 'color', 'gray')}

                                    onClick={
                                      // data.data[key].penggunaan_stock[keyPS].stock_status === utils.stockItemStatus.tagged.value ?
                                      () => {
                                        setData(d => ({
                                          ...d,
                                          taggedInfo: {
                                            ...d.taggedInfo,
                                            customerName: data.data[key].penggunaan_stock[keyPS].customer_name,
                                            projectId: data.data[key].penggunaan_stock[keyPS].tagged_project_id,
                                            modal: true
                                          }
                                        }));
                                      }
                                      // : () => { }
                                    }

                                    sx={(tema) => ({
                                      cursor: 'pointer',
                                      // cursor: data.data[key].penggunaan_stock[keyPS].stock_status === utils.stockItemStatus.tagged.value ? 'pointer' : 'default'
                                    })}

                                    styles={(tema) => ({
                                      inner: {
                                        fontWeight: 'normal',
                                        textTransform: 'none',
                                      }
                                    })}
                                  >
                                    {getObjectParam2(utils.stockItemStatus, data.data[key].penggunaan_stock[keyPS].stock_status, 'caption', ' - ')}
                                  </Badge>
                                </Group>

                                {
                                  // data.data[key].penggunaan_stock[keyPS].stock_status === utils.stockItemStatus.tagged.value && 
                                  data.data[key].penggunaan_stock[keyPS].customer_name &&
                                  <Text size='xs' color={getObjectParam2(utils.stockItemStatus, data.data[key].penggunaan_stock[keyPS].stock_status, 'color', 'gray')} mt='.25rem'>
                                    Tagged : {safeValue(data.data[key].penggunaan_stock[keyPS].customer_name, ' - ')}
                                  </Text>
                                }

                                {
                                  // data.data[key].penggunaan_stock[keyPS].stock_status === utils.stockItemStatus.tagged.value && 
                                  data.data[key].penggunaan_stock[keyPS].tagged_project_id &&
                                  <Text size='xs' color={getObjectParam2(utils.stockItemStatus, data.data[key].penggunaan_stock[keyPS].stock_status, 'color', 'gray')}>
                                    Tagged : {stringDivider(data.data[key].penggunaan_stock[keyPS].tagged_project_id, [4, 6, 8], '.', ' - ')}
                                  </Text>
                                }

                                <Text size='sm' color="dimmed" mt='xs'>
                                  Jumlah Pemakaian: {data.data[key].penggunaan_stock[keyPS].project_pengerjaan_stock_jumlah_penggunaan}
                                </Text>
                              </Box>
                            </Group>

                            {/* {!Boolean(Number(data.data[key].project_pengerjaan_is_sudah_posting)) && */}
                            {utils.projectProcess.pengerjaan.value === stateData.projectProcess &&
                              canAccessModifyPengerjaan({ stateObject: { subLevel: loginContext } }) &&
                              <Menu
                                shadow="md"
                                ml='auto'
                                position='bottom-end'
                              >
                                <Menu.Target>
                                  <ActionIcon
                                    size='md'
                                    variant="subtle"
                                    radius='xl'

                                    sx={(tema) => ({
                                      backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[5],
                                      '&:hover': {
                                        backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[2] : tema.colors.dark[4]
                                      },
                                    })}
                                  >
                                    <IconDotsVertical size='1rem' />
                                  </ActionIcon>
                                </Menu.Target>

                                <Menu.Dropdown>
                                  <Menu.Item
                                    onClick={() => {
                                      taggedInit(
                                        data.data[key].penggunaan_stock[keyPS].tagged_project_id,
                                        data.projectId,
                                        data.data[key].penggunaan_stock[keyPS].tagged_client_id,
                                        data.clientId
                                      );

                                      setData(d => ({
                                        ...d,
                                        batalPemakaianModal: true,
                                        batalPemakaianType: refDefaultGaransiType.current,
                                        batalPemakaianJumlah: '',
                                        // batalPemakaianError: '',
                                        batalPemakaianKeterangan: '',
                                        // batalPemakaianIsTaggedForClientId: false,
                                        // batalPemakaianIsTaggedForClientIdDisabled: false,
                                        // batalPemakaianIsTaggedForProjectId: false,

                                        batalPemakaianItemData: {
                                          ...d.batalPemakaianItemData,
                                          name: `${safeValue(data.data[key].penggunaan_stock[keyPS].stock_category_name, ' ')} ${safeValue(data.data[key].penggunaan_stock[keyPS].stock_category_sub_name, ' ')} ${safeValue(data.data[key].penggunaan_stock[keyPS].stock_serial_number, ' ')}`,
                                          itemStatus: data.data[key].penggunaan_stock[keyPS].stock_status,
                                          masaGaransiType: data.data[key].penggunaan_stock[keyPS].stock_masa_garansi_type,
                                          masaGaransiBulan: data.data[key].penggunaan_stock[keyPS].stock_masa_garansi_bulan,
                                          masaGaransiHari: data.data[key].penggunaan_stock[keyPS].stock_masa_garansi_hari,
                                          masaGaransiCanBeClaimed: data.data[key].penggunaan_stock[keyPS].can_be_claimed,
                                          stockId: data.data[key].penggunaan_stock[keyPS].stock_id,
                                          pengerjaanId: data.data[key].penggunaan_stock[keyPS].project_pengerjaan_id,
                                          pengerjaanStockId: data.data[key].penggunaan_stock[keyPS].project_pengerjaan_stock_id,
                                          // taggedClientId: data.data[key].penggunaan_stock[keyPS].tagged_client_id,
                                          // taggedProjectId: data.data[key].penggunaan_stock[keyPS].tagged_project_id,
                                          clientName: data.clientName,
                                          clientId: data.clientId,
                                          projectId: data.projectId,
                                          tanggalPembelian: data.data[key].penggunaan_stock[keyPS].stock_tanggal_beli
                                        }
                                      }))
                                    }}
                                  >
                                    Batalkan
                                  </Menu.Item>
                                </Menu.Dropdown>
                              </Menu>
                            }
                          </Group>
                        )
                      })}
                    </Box>
                  }

                  {Array.isArray(data.data[key].pengerjaan_foto) && (data.data[key].pengerjaan_foto.length > 0) &&
                    <Divider my='sm' />
                  }

                  <CarouselPhotos
                    stateData={{
                      data: data.data[key].pengerjaan_foto,
                      propName: 'project_pengerjaan_foto_name',
                      propId: 'project_pengerjaan_foto_id',
                      imageTitleOnClick: 'Gambar Barang - Pengerjaan',
                      canDelete: !Boolean(Number(data.data[key].project_pengerjaan_is_sudah_posting)) && canAccessModifyPengerjaan({ stateObject: { subLevel: loginContext } })
                    }}

                    stateUtils={{
                      heightImage: 150,
                      slideSize: "33.333333%",
                      imgAlt: 'gambar-barang-pengerjaan',
                      showImageCounter: true
                    }}

                    stateWhenNoData={{
                      showThisComponent: false,
                      component: 'No Data'
                    }}

                    fnOnClickImage={(object) => fnClickPhoto(object)}

                    fnOnClickDelete={(object) => {
                      setData(d => ({
                        ...d,
                        deletePhoto: {
                          ...d.deletePhoto,
                          photoId: object.id,
                          photoName: object.name,
                          progressPengerjaanId: data.data[key].project_pengerjaan_id,
                          confirmation: true
                        }
                      }));
                    }}
                  />

                  {data.data[key].project_pengerjaan_flag === utils.pengerjaanProgress.pengerjaan.value &&
                    Number(data.data[key].project_pengerjaan_is_sudah_posting) === 0 &&
                    stateData.projectProcess === utils.projectProcess.pengerjaan.value &&
                    canAccessModifyPengerjaan({ stateObject: { subLevel: loginContext } }) &&
                    <Box>
                      <Divider my='sm' />

                      <Group
                        position="apart"
                        noWrap
                        align='flex-start'
                      >
                        <Group
                          noWrap
                          align='flex-start'
                          spacing='.5rem'
                        >
                          <FileSelectorComponent
                            fnAddOnSelect={(val) => uploadFile(val, data.data[key].project_pengerjaan_id)}
                            fnUploadLoading={(val) => setData(d => ({ ...d, fileUploading: val }))}
                            stateUploadLoading={data.fileUploading}
                            stateUploadProgress={data.fileUploadingProgress}
                          />

                          {Number(data.data[key].project_pengerjaan_is_pengecekan) === 0 &&
                            <ComponentStockSelector
                              stateShow={data.stockSelectorModal}
                              fnShow={() => setData(d => ({ ...d, stockSelectorModal: false }))}

                              stateData={stateData}
                              statePreventNotChange={data.stockSelectorTriggerUpdate}
                              statePengerjaanProgresId={data.data[key].project_pengerjaan_id}
                              fnResult={(val) => {
                                setData(d => ({
                                  ...d,
                                  data: val,
                                  dataFlag: val.length > 0 ? true : false,
                                  taggedItemRefresh: new Date()
                                }));
                              }}
                            >
                              <Button
                                variant="light"
                                size="xs"
                                leftIcon={<IconPlus size={10} />}
                                styles={(theme) => ({
                                  leftIcon: {
                                    marginRight: '3px',
                                  },
                                })}

                                onClick={() => setData(d => ({
                                  ...d,
                                  stockSelectorModal: true,
                                  stockSelectorTriggerUpdate: new Date()
                                }))}
                              >
                                Stok
                              </Button>
                            </ComponentStockSelector>
                          }
                        </Group>

                        <Button
                          variant="light"
                          size="xs"
                          onClick={() => {
                            setData(d => ({
                              ...d,
                              posting: {
                                ...d.posting,
                                progressPengerjaanId: data.data[key].project_pengerjaan_id,
                                confirmation: true
                              }
                            }))
                          }}
                        >
                          Posting
                        </Button>
                      </Group>
                    </Box>
                  }
                </PaperWrapper>
              </Box>
            )
          })}

          {stateData.projectProcess === utils.projectProcess.pengerjaan.value &&
            !data.data.some(item => Number(item.project_pengerjaan_is_pengecekan) === 1) &&
            canAccessModifyPengerjaan({ stateObject: { subLevel: loginContext } }) &&
            <Group
              spacing={5}
              px='xs'
              py='0.25rem'
              mt='md'
              position="center"

              sx={(tema) => ({
                borderWidth: '1px',
                borderStyle: 'dashed',
                borderColor: tema.colorScheme === 'light' ? tema.colors.teal[6] : tema.colors.teal[6],
                borderRadius: tema.radius.sm,
                color: tema.colorScheme === 'light' ? tema.colors.teal[6] : tema.colors.teal[6],
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.teal[3], 0.1) : tema.fn.rgba(tema.colors.teal[9], 0.1),
                }
              })}

              onClick={() => setData(d => ({
                ...d,
                addPengecekanModal: true
              }))}
            >
              <IconPlus size='0.8rem' />
              <Text size='sm'>Pengecekan</Text>
            </Group>
          }

          {stateData.projectProcess === utils.projectProcess.pengerjaan.value &&
            data.data.some(item => Number(item.project_pengerjaan_is_pengecekan) === 1) &&
            canAccessModifyPengerjaan({ stateObject: { subLevel: loginContext } }) &&
            <Group
              spacing={5}
              px='xs'
              py='0.25rem'
              mt='md'
              position="center"

              sx={(tema) => ({
                borderWidth: '1px',
                borderStyle: 'dashed',
                borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                borderRadius: tema.radius.sm,
                color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
                }
              })}

              onClick={() => setData(d => ({
                ...d,
                addProgressModal: true
              }))}
            >
              <IconPlus size='0.8rem' />
              <Text size='sm'>Tambah Progres</Text>
            </Group>
          }

          {stateShowNextComponent && canAccessModifyPengerjaan({ stateObject: { subLevel: loginContext } }) &&
            <Box mt='3rem' mb='4rem'>
              <PaperWrapper>
                <Text size='sm' mb='xs' color="dimmed">
                  Project sudah selesai dikerjakan ?
                </Text>

                <Divider />

                <Text size='sm' my='xs' color="dimmed">
                  Pastikan barang sudah diperbaiki dengan benar. Setelah ini barang akan masuk ke tahap Q.C
                </Text>

                <Button
                  fullWidth
                  onClick={() => {
                    setData(d => ({ ...d, submitConfirmationModal: true }));
                  }}
                >
                  Selesai Pengerjaan dan Lanjut Q.C
                </Button>
              </PaperWrapper>
            </Box>
          }
        </Box>
      }

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />

      <ModalTakeAction
        stateShow={data.addProgressModal}
        fnHide={() => setData(d => ({ ...d, addProgressModal: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Tambah Progres')}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'
        stateSize="lg"

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor="blue"
        stateButtonActionLoading={data.addProgressSubmitLoading}
        fnButtonAction={addProgress}
      >
        <Textarea
          value={data.addProgressValue}
          minRows={4}
          maxRows={5}
          onChange={(e) =>
            setData(d => ({
              ...d,
              addProgressValue: e.target.value
            }))
          }

          label=''
          placeholder='Progres'
          error={data.addProgressError}
          description=''
          withAsterisk={true}
        />
      </ModalTakeAction>

      <ModalTakeAction
        stateShow={data.addPengecekanModal}
        fnHide={() => setData(d => ({ ...d, addPengecekanModal: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Pengecekan')}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'
        stateSize="lg"

        stateButtonActionCaption='Submit Pengecekan'
        stateButtonActionPx='xs'
        stateButtonActionColor="teal"
        stateButtonActionLoading={data.addPengecekanSubmitLoading}
        fnButtonAction={addPengecekan}
      >
        <Textarea
          value={data.addPengecekanValue}
          minRows={4}
          maxRows={5}
          onChange={(e) =>
            setData(d => ({
              ...d,
              addPengecekanValue: e.target.value
            }))
          }

          label=''
          placeholder='Pengecekan'
          error={data.addPengecekanError}
          description=''
          withAsterisk={true}
        />
      </ModalTakeAction>

      <ModalTakeAction
        stateShow={data.editDescModal}
        fnHide={() => setData(d => ({ ...d, editDescModal: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Edit Progres')}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'
        stateSize="lg"

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor="blue"
        stateButtonActionLoading={data.editDescSubmitLoading}
        fnButtonAction={editDesc}
      >
        <Textarea
          value={data.editDescValue}
          minRows={4}
          maxRows={5}
          onChange={(e) =>
            setData(d => ({
              ...d,
              editDescValue: e.target.value
            }))
          }

          label=''
          placeholder='Progres'
          error={data.editDescError}
          description=''
          withAsterisk={true}
        />
      </ModalTakeAction>

      <ModalTakeAction
        stateShow={data.batalPemakaianModal}
        fnHide={() => setData(d => ({ ...d, batalPemakaianModal: false }))}

        stateHideOnClickOutSide={false}
        stateTitle={String('Pengembalian Item').toUpperCase()}
        stateOverlayZIndex={201}
        stateScrollArea={true}

        stateButtonClosePx='md'
        stateSize="lg"

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor=""
        stateButtonActionLoading={data.batalPemakaianLoadingSubmit}
        fnButtonAction={batalkanPemakaianPart}
      >
        <Paper
          mt='sm'
          p='sm'
          sx={(tema) => ({
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.5) : tema.fn.rgba(tema.colors.blue[9], 0.5),
            borderRadius: tema.radius.sm,
            // color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
            // backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
            fontSize: tema.fontSizes.sm,
          })}
        >
          <LabelContentInline
            stateColLabel={3}
            stateLabel='Item'
            stateContent={
              <Group spacing='xs'>
                <Text
                  sx={{
                    wordBreak: 'break-word'
                  }}
                >
                  {data.batalPemakaianItemData.name}
                </Text>

                <Badge
                  size='md'
                  color={getObjectParam2(utils.stockItemStatus, data.batalPemakaianItemData.itemStatus, 'color', 'gray')}

                  styles={() => ({
                    inner: {
                      fontWeight: 'normal',
                    }
                  })}
                >
                  {getObjectParam2(utils.stockItemStatus, data.batalPemakaianItemData.itemStatus, 'caption', ' - ')}
                </Badge>
              </Group>
            }
            stateDivider={false}
          />

          <LabelContentInline
            stateColLabel={3}
            stateLabel='Garansi Supplier'
            stateContent={masaGaransiUtils__1({
              stateGaransiType: data.batalPemakaianItemData.masaGaransiType,
              stateGaransiBulan: data.batalPemakaianItemData.masaGaransiBulan,
              stateGaransiHari: data.batalPemakaianItemData.masaGaransiHari,
              stateTanggalPembelian: data.batalPemakaianItemData.tanggalPembelian,
              stateShowTanggalPembelian: true,
            })}
            stateDivider={false}
          />

          {/* <LabelContentInline
                        stateColLabel={3}
                        stateLabel='Garansi Client'
                        stateContent={masaGaransiUtils__1({
                            stateGaransiType: data.batalPemakaianItemData.masaGaransiType,
                            stateGaransiBulan: data.batalPemakaianItemData.masaGaransiBulan,
                            stateGaransiHari: data.batalPemakaianItemData.masaGaransiHari,
                            stateTanggalPembelian: data.batalPemakaianItemData.tanggalPembelian,
                            stateShowTanggalPembelian: true,
                        })}
                        stateDivider={false}
                    /> */}

          <LabelContentInline
            stateColLabel={0}
            stateLabel=''
            stateContent={
              <Text
                color={masaGaransiUtils__2({
                  stateGaransiType: data.batalPemakaianItemData.masaGaransiType,
                  stateCanBeClaimed: data.batalPemakaianItemData.masaGaransiCanBeClaimed,
                  stateColorCanBeClaimed: 'blue',
                  stateColorCannotBeClaimed: 'red'
                }).colorCanBeClaimed}
              >
                {masaGaransiUtils__2({
                  stateGaransiType: data.batalPemakaianItemData.masaGaransiType,
                  stateCanBeClaimed: data.batalPemakaianItemData.masaGaransiCanBeClaimed,
                }).isCanBeClaimedCaption}
              </Text>
            }
            stateDivider={false}
          />
        </Paper>

        <Box
          mt='2rem'
          mb='1rem'
        >
          <InputWrapperCustom
            stateLabel='Pilihan Pembatalan'
            stateWithAsterisk={false}
            stateError=''
            stateDescription=''
          >
            <Select
              value={data.batalPemakaianType}
              onChange={(val) => setData(d => ({ ...d, batalPemakaianType: val }))}
              data={batalPemakaianSelectorByGaransiTypeCanBeClaimed({
                stateGaransiType: data.batalPemakaianItemData.masaGaransiType,
                stateCanBeClaimed: data.batalPemakaianItemData.masaGaransiCanBeClaimed
              })}

              dropdownPosition="top"
            />
          </InputWrapperCustom>

          <Text size='.8rem' color="dimmed" mt='.5rem'>
            {getObjectParam2(utils.batalPemakaianItem, data.batalPemakaianType, 'description', '')}
          </Text>
        </Box>

        <Box
          mb='1rem'
        >
          <InputComponent
            stateId='pembatalan-jumlah'
            stateWithAsterisk={false}
            stateLabel='Jumlah item yang akan dibatalkan'
            stateDescription=''
            statePlaceHolder='Jumlah'
            stateValue={data.batalPemakaianJumlah}
            stateError=''

            fnOnChange={(e) => setData(d => ({
              ...d,
              batalPemakaianJumlah: regexNumberOnly(e.target.value)
            }))}
          />
        </Box>

        {data.batalPemakaianType !== utils.batalPemakaianItem.salah_pilih.slug &&
          <Textarea
            value={data.batalPemakaianKeterangan}
            minRows={4}
            maxRows={5}
            onChange={(e) =>
              setData(d => ({
                ...d,
                batalPemakaianKeterangan: e.target.value
              }))
            }

            label='Keterangan Pembatalan'
            placeholder='Keterangan'
            error=''
            description=''
            withAsterisk={false}
            mb='sm'
          />
        }

        {data.batalPemakaianType === utils.batalPemakaianItem.rusak_ada_garansi.slug &&
          <React.Fragment>
            <Divider my='sm' />

            <Checkbox
              label={`Tag item ini untuk ${data.batalPemakaianItemData.clientName}`}
              checked={data.batalPemakaianIsTaggedForClientId}
              onChange={(event) => setData(d => ({
                ...d,
                batalPemakaianIsTaggedForClientId: event.target.checked
              }))}
              disabled={data.batalPemakaianIsTaggedForClientIdDisabled}

              description={`Jika opsi ini dipilih, maka item ini akan dikhusukan untuk ${data.batalPemakaianItemData.clientName}`}

              mb='xs'
            />

            <Checkbox
              label={`Tag item ini untuk project (nota) ${stringDivider(data.batalPemakaianItemData.projectId, [4, 6, 8], '.', '[Nomor Nota]')}`}
              checked={data.batalPemakaianIsTaggedForProjectId}
              onChange={(event) => setData(d => ({
                ...d,
                batalPemakaianIsTaggedForProjectId: event.target.checked
              }))}

              description={`Jika opsi ini dipilih, maka item ini akan dikhusukan untuk ${data.batalPemakaianItemData.clientName} dan project (nota) ${stringDivider(data.batalPemakaianItemData.projectId, [4, 6, 8], '.', '[Nomor Nota]')}`}
            />
          </React.Fragment>
        }

        {data.batalPemakaianError &&
          <Text size='sm' color="red" my='sm'>
            {data.batalPemakaianError}
          </Text>
        }
      </ModalTakeAction>

      <ModalTakeAction
        stateShow={data.deletePhoto.confirmation}
        fnHide={() => setData(d => ({
          ...d,
          deletePhoto: {
            ...d.deletePhoto,
            confirmation: false
          }
        }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Confirmation').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Hapus'
        stateButtonActionPx='xs'
        stateButtonActionColor="red"
        stateButtonActionLoading={data.deletePhoto.deleteLoading}
        fnButtonAction={deletePhoto}
      >
        <Text size='sm'>
          Hapus foto ini ?
        </Text>
      </ModalTakeAction>

      <ModalTakeAction
        stateShow={data.posting.confirmation}
        fnHide={() => setData(d => ({
          ...d,
          posting: {
            ...d.posting,
            confirmation: false
          }
        }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Confirmation').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Posting'
        stateButtonActionPx='xs'
        stateButtonActionColor="blue"
        stateButtonActionLoading={data.posting.postingLoading}
        fnButtonAction={postingProgress}
      >
        <Text size='sm' mt='sm' color="dimmed">
          Progres yang telah diposting tidak akan dapat diedit/ubah/hapus.
          <br />
          Posting progres ini ?
        </Text>
      </ModalTakeAction>

      <ModalTakeAction
        stateShow={data.batalkanProgress.confirmation}
        fnHide={() => setData(d => ({
          ...d,
          batalkanProgress: {
            ...d.batalkanProgress,
            confirmation: false
          }
        }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Confirmation').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Ya, Batalkan'
        stateButtonActionPx='xs'
        stateButtonActionColor="red"
        stateButtonActionLoading={data.batalkanProgress.batalkanLoading}
        fnButtonAction={batalkanProgress}
      >
        <Text size='sm' mt='sm' color="dimmed">
          Batalkan progres ini ?
        </Text>
      </ModalTakeAction>

      <StepPengerjaanReminderMaintenanceModal
        stateShow={data.submitConfirmationModal}
        fnShow={() => setData(d => ({ ...d, submitConfirmationModal: false }))}

        stateData={{
          projectId: stateData.projectId,
          projectProcess: stateData.projectProcess,
          projectIsCancel: stateData.projectIsCancel
        }}

        fnSuccess={() => {
          fnCloseDrawer();

          notifications.show({
            id: notificationId.current.successSubmitData,
            title: utils.notification.success.caption,
            message: 'Berhasil Submit Data',
            color: utils.notification.success.color,
            icon: utils.notification.success.icon,
            withBorder: true,
            autoClose: true,
          })

          fnSuccessTakesThisProject();
        }}
      />

      <ModalWrapperWithFooterCloseButton
        stateShow={data.taggedInfo.modal}
        fnHide={() => setData(d => ({ ...d, taggedInfo: { ...d.taggedInfo, modal: false } }))}
        stateHideOnClickOutSide={true}
        stateTitle={String('Information').toUpperCase()}
        // stateSize='xl'
        stateOverlayZIndex={201}
        stateWithCloseButton={true}
        stateScrollArea={true}

        stateButtonCloseCaption="Close"
        stateButtonCloseSize="xs"
        stateButtonClosePx="lg"
      >
        {data.taggedInfo.customerName ?
          <Text size='sm' color='dimmed'>
            Item ini sudah ditandai untuk customer <Mark>&nbsp;{safeValue(data.taggedInfo.customerName, ' - ')}&nbsp;</Mark>
          </Text>
          :
          <Text size='sm' color='dimmed'>
            Tidak ada customer tag untuk item ini.
          </Text>
        }

        {data.taggedInfo.projectId ?
          <Text size='sm' color='dimmed'>
            Item ini sudah ditandai untuk project <Mark>&nbsp;{stringDivider(data.taggedInfo.projectId, [4, 6, 8], '.', ' - ')}&nbsp;</Mark>
          </Text>
          :
          <Text size='sm' color='dimmed'>
            Tidak ada project tag untuk item ini.
          </Text>
        }
      </ModalWrapperWithFooterCloseButton>
    </React.Fragment>
  )
}

const BadgeCustomGreen = ({ stateLabel }) => {
  return (
    <Badge
      size='md'
      mb='.25rem'
      color='green'
      variant='outline'

      styles={(tema) => ({
        inner: {
          fontWeight: 'normal',
          textTransform: 'none',
        },
      })}
    >
      {stateLabel}
    </Badge>
  )
}

const BadgeCustomRed = ({ stateLabel }) => {
  return (
    <Badge
      size='md'
      mb='.25rem'
      color='red'

      styles={(tema) => ({
        inner: {
          fontWeight: 'normal',
          textTransform: 'none',
        },
        root: {
          borderColor: tema.colorScheme === 'light' ? tema.colors.red[4] : tema.colors.red[9],
          borderWidth: '1px',
          borderStyle: 'solid'
        }
      })}
    >
      {stateLabel}
    </Badge>
  )
}

const CardTaggedItem = ({ children }) => {
  return (
    <Card
      p='sm'
      mb='1rem'
      sx={(tema) => ({
        backgroundColor: tema.colorScheme === 'light' ? tema.colors.green[0] : tema.fn.rgba(tema.colors.green[8], 0.2),
        borderColor: tema.colorScheme === 'light' ? tema.colors.green[1] : tema.fn.rgba(tema.colors.green[9], 0.2),

        borderWidth: '1px',
        borderStyle: 'solid'
      })}
    >
      {children}
    </Card>
  )
}

export default StepPengerjaan;